import {
	WS_INV_FILTERS
} from '../global-constants.js';

import { getWalletConfig } from '../helpers/index.js';
import openSDPWithRoute from '../utils/openSDPWithRoute.js';

export const getOpenWalletLink = (label, classes, showPaymentsPanel, vehicle, paymentData, selectedPanel, isNewComparePage) => {
	const walletLink = document.createElement('a');
	walletLink.addEventListener('click', async (e) => {
		e.preventDefault();

		if (!vehicle) {
			const selectedPanelObject = selectedPanel ? {
				selectedPanelName: selectedPanel
			} : {};

			window.caiEventBus.emit('wallet:open', selectedPanelObject);

			// Close the filters panel on mobile so we can see Wallet
			if (window?.DDC?.pubsub) {
				window.DDC.pubsub.publish(`${WS_INV_FILTERS}/close-filters`, window?.DDC?.client?.isMobile);
			}

			return;
		}

		if (!(paymentData?.leasePayment?.payment || paymentData?.financePayment?.payment)) {
			return;
		}

		const walletData = await getWalletConfig();

		// Setting the monthly budget explicitly here appears to be necessary.
		// If you don't, the My Wallet data changes to use a monthly budget of
		// 95% of your originally set budget when you open the payments panel.
		// This may be a bug in the payments panel code, and this is a workaround
		// for now to make the product function properly.
		const {
			finalPrice,
			inventoryType,
			link,
			msrp,
			uuid
		} = vehicle;

		const {
			financePayment,
			leasePayment
		} = paymentData;

		const {
			creditType
		} = walletData;

		let leaseOfferDetails = {};
		if (leasePayment?.payment && leasePayment?.term) {
			leaseOfferDetails = {
				leaseOffers: {
					[leasePayment.term]: [
						{
							payment: leasePayment.payment,
							offeredBy: leasePayment.lenderName,
						},
					],
				}
			};
		};

		// Open the payments panel specifically once the user has first interacted with Wallet.
		const paymentsPanel = showPaymentsPanel ? {
			modal: 'paymentDetails',
			inventory: {
				id: uuid,
				pricingDetail: {
					salePrice: finalPrice,
					msrp
				},
				type: inventoryType,
				website: {
					href: link
				},
				// Set the Payments Modal data the correct way which will be used in the near future.
				vehiclePaymentDetails: {
					rates: {
						[creditType]: {
							paymentOffers: {
								[financePayment.term]: [{
									offeredBy: financePayment.lenderName,
									payment: financePayment.payment,
									[inventoryType]: parseFloat(financePayment.apr)
								}]
							},
							...leaseOfferDetails,
						}
					}
				}
			}
		} : {};

		window.caiEventBus.emit('wallet:open', paymentsPanel);
	});

	walletLink.setAttribute('href', '#');
	walletLink.setAttribute('title', 'My Wallet');

	if (classes) {
		walletLink.setAttribute('class', classes);
	}

	if(label){
		if(isNewComparePage && showPaymentsPanel){
			walletLink.innerHTML = '<a class="ddc-icon-edit-doc ddc-icon ddc-nav-icon text-muted"></a>';
		}
		else{
			walletLink.innerText = label;
		}
	}

	return walletLink;
}



export const getCreditCTALink = (label, classes, refreshDsAfterSdpClose) => {
	const openCreditCTA =  document.createElement('a');
	openCreditCTA.addEventListener('click', () => openSDPWithRoute('credit', refreshDsAfterSdpClose));
	
	if (classes) {
		openCreditCTA.setAttribute('class', classes);
	}

	openCreditCTA.setAttribute('href', '#');
	openCreditCTA.innerText = label;
	return openCreditCTA;
}
